import { z } from 'zod';
import { SourceSystem, StockEntryType } from '../enums.js';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/**
 * MovementEvent — canonical, generated by adapters from external source data.
 * Adapter pulls from 1C/Bitrix/Adesk/XLSX → produces MovementEvent[].
 * Adapters DO NOT write to SLE — MovementEvent lives only in staging / analytics.
 */
export const MovementEvent = z.object({
  id: UuidString,
  entity_id: UuidString,

  source_system: SourceSystem,
  source_document_id: z.string(),
  source_system_ref: z.record(z.unknown()).nullable(),
  fetched_at: IsoDateTime,

  posting_datetime: IsoDateTime,
  stock_entry_type: StockEntryType,

  item_source_ref: z.string(), // source sku/id для resolve в Item
  item_id: UuidString.nullable(),

  from_warehouse_ref: z.string().nullable(),
  to_warehouse_ref: z.string().nullable(),
  from_warehouse_id: UuidString.nullable(),
  to_warehouse_id: UuidString.nullable(),

  batch_ref: z.string().nullable(),
  batch_id: UuidString.nullable(),

  qty: DecimalString,
  uom: z.string().min(1),
  rate: MoneyAmount.nullable(),

  raw_payload: z.record(z.unknown()),

  created_at: IsoDateTime,
});
export type MovementEvent = z.infer<typeof MovementEvent>;
